import { Suspense } from "react";
import {
  Button, Col, Flex, Row
} from "antd";
import HeroScreen from "../components/HeroScreen/heroScreen";
import Layout from "../components/layout";
import { HowItWorksContent } from "../components/Screens/howItWorks";
import AdvantagesScreen from "../components/Screens/advantages";
import Container from "../components/container";
import { useNav } from "../hooks/useNav";

const HowItWorksPage = () => {
  const { navSurvey, navContacts } = useNav();
  return (
    <Layout>
      <HeroScreen>
        <h1 className="heroTitle text-center mb-[3rem]">Come funziona</h1>
        <HowItWorksContent/>
      </HeroScreen>
      <div>
        <Container className="py-12 overflow-visible">
          <h2 className="heading mb-2">Prezzi chiari</h2>
          <p className="text-base mb-10">
            Offriamo un servizio di psiconcologia a un costo fisso di 59€ per ogni teleconsulto.
            Il prezzo è trasparente e comunicato chiaramente al momento della prenotazione,
            senza costi nascosti.
          </p>
          <Row gutter={24}>
            <Col span={24} lg={16}>
              <div className="relative w-full h-full">
                <img src="/landing/how-it-works-img.png" alt="img" className="w-full h-full desktop_absolute top-0 left-0 object-cover"/>
              </div>
            </Col>
            <Col span={24} lg={8}>
              <Flex
                vertical
                align="center"
                className="p-12 text-base rounded-[6px] border-solid border-[#d5d6d9]"
                style={{
                  boxShadow: "0 1rem 3rem rgba(16,24,40,.175)"
                }}
              >
                <Flex gap={8} vertical className="text-center mb-10">
                  <span>Primo colloquio conoscitivo gratuito di 15-20 minuti</span>
                  <span className="text-[2.5rem] leading-1 text-bold">59€</span>
                  <span>Seduta singola</span>
                </Flex>
                <Flex gap={12} className="mb-10">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect width="24" height="24" rx="12" fill="#DCFAE6"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.096 7.39016L9.93602 14.3002L8.03602 12.2702C7.68602 11.9402 7.13602 11.9202 6.73602 12.2002C6.34602 12.4902 6.23602 13.0002 6.47602 13.4102L8.72602 17.0702C8.94602 17.4102 9.32601 17.6202 9.75601 17.6202C10.166 17.6202 10.556 17.4102 10.776 17.0702C11.136 16.6002 18.006 8.41016 18.006 8.41016C18.906 7.49016 17.816 6.68016 17.096 7.38016V7.39016Z" fill="#17B26A"/>
                  </svg>
                  <span className="text-[#475467]">50 minuti di consulenza con uno specialista assegnato</span>
                </Flex>
                <Flex vertical gap={16} className="w-full">
                  <Button type="primary" size="large" block onClick={navSurvey}>Inizia questionario</Button>
                  <Button type="dashed" size="large" block onClick={navContacts}>Contattaci</Button>
                </Flex>
              </Flex>
            </Col>
          </Row>
        </Container>
      </div>
      <Suspense>
        <AdvantagesScreen
          title={(
            <>
              Tecnologia al servizio
              <br/>
              della salute
            </>
          )}
          description="La nostra piattaforma utilizza tecnologie all'avanguardia per offrire un supporto psicologico efficace e sicuro a chi affronta la malattia oncologica. Grazie a strumenti innovativi e un'interfaccia intuitiva, puoi accedere al tuo percorso di sostegno ovunque ti trovi, con la massima flessibilità e sicurezza."
        />
      </Suspense>
    </Layout>
  );
};

export default HowItWorksPage;
